export enum VALIDATION_MESSAGE_KEYS {
  EMAIL = 'form:validation.string.email',
  NUMBER_MAX = 'form:validation.number.max',
  NUMBER_MIN = 'form:validation.number.min',
  NUMBER_REQUIRED = 'form:validation.number.required',
  STRING_MAX = 'form:validation.string.max',
  STRING_MIN = 'form:validation.string.min',
  STRING_REQUIRED = 'form:validation.string.required',
  URL = 'form:validation.string.url',
  DATE_REQUIRED = 'form:validation.date.required',
  DATE = 'form:validation.string.date',
  DATE_FUTURE = 'form:validation.date.future',
  DATE_MIN = 'form:validation.date.min',
  DATE_MAX = 'form:validation.date.max',
  TIME = 'form:validation.string.time',
  TIME_MIN = 'form:validation.time.min',
  TIME_MAX = 'form:validation.time.max',
  TIME_REQUIRED = 'form:validation.time.required',
  STUDYGROUP_MIN_CHILDREN_WITH_ADULTS = 'form:validation.studygroup.childrenandadultmin',
  STUDYGROUP_MAX_WITH_CHILDREN = 'form:validation.studygroup.adultmaxwithchildren',
  STUDYGROUP_MAX_WITH_ADULTS = 'form:validation.studygroup.childrenmaxwithadults',
  STUDYGROUP_MAX_CHILDREN_WITH_ADULTS = 'form:validation.studygroup.childrenandadultmax',
}
